<template lang="pug">
div
  app-divider(label="Dados do Título")
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Nome do beneficiário")
        app-label(label="Nome do beneficiário:", :required="required")
        el-input.input(
          v-model="imovel.nomeBeneficiarioTitulo",
          name='Nome do beneficiário',
          maxlength="300"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="8")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/N° do Título")
        app-label(label="N° do título:", :required="required")
        el-input.input(
          v-model="imovel.numeroTitulo",
          name='N° do Título',
          maxlength="100"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="8")
      validation-provider(:rules="isRequiredArea", v-slot="{ errors }", name="Imóvel/Área Titulo")
        app-label(label="Área:", :required="required")
        app-double-input.input(
          v-model="imovel.areaTitulo",
          name='Área Titulo',
          :precision="4",
          :onkeypress="onlyInputNumbers",
          :class="{'erro' : errors.length}"
          :showAppend ="true"
        )
        span.help.erro {{ errors[0] }}

  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Data de Expedição")
        app-label(label="Data de expedição:", :required="required")
        el-date-picker.input.select(
          type="date",
          name='Data de expedição'
          v-model="imovel.dataExpedicaoTitulo",
          placeholder="Selecione",
          format="dd/MM/yyyy",
          v-mask="'##/##/#####'",
          :picker-options="pickerOptions",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="8")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Município do Titulo")
        app-label(label="Município:", :required="required")
        el-select.input(
          class="select",
          v-model="imovel.municipioTitulo",
          no-match-text="Nenhum Município Encontrado",
          placeholder="Selecione",
          filterable,
          clearable,
          @clear="imovel.municipioTitulo = null"
          value-key="id",
          name="Município do Titulo",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/N° do Lote")
        app-label(:label="labelsCadastro.imovel.lote", :required="required")
        el-input.input(
          v-model="imovel.numeroLote",
          :name='labelsCadastro.imovel.lote',
          maxlength="100"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
</template>
<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppData from '@/components/AppData'
import AppDoubleInput from '@/components/AppDoubleInput'
const {labelsCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDivider,
    AppLabel,
    AppData,
    AppDoubleInput
  },
  props: {
    imovel: {
      required: true
    },
    // prop que define se os campos são obrigatorios
    required: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      labelsCadastro,
      municipios: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    this.getMunicipiosByUf()
  },

  computed: {
    isRequired () {
      return this.required ? 'required' : ''
    },
    isRequiredArea () {
      return this.required ? 'required|min_value:0.00001' : ''
    }
  },

  methods: {
    async getMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, process.env.ESTADO)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.select {
  width: 100%;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppImovelDadosTitulo.vue